exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".well[data-v-1442fac0]{border-right:1px solid #000;padding:20px}.form[data-v-1442fac0]{text-align:right;padding-top:20px}.columm[data-v-1442fac0]{margin-bottom:20px}.signup[data-v-1442fac0]{padding:20px 0;border-radius:5px;width:320px}.text-center[data-v-1442fac0]{text-align:center}.signupForm[data-v-1442fac0]{width:75%;margin:auto}.label150[data-v-1442fac0]{label-width:150px}@media (max-width:900px){.signupForm[data-v-1442fac0]{width:100%}.label150[data-v-1442fac0]{label-width:5px}}.facebook[data-v-1442fac0]{background:#3b5898;color:#fff}.login-block[data-v-1442fac0]{min-height:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1442fac0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/auth/Authentication.vue
// module id = kEO2
// module chunks = 0